<div class="container">
    <div class="logo">
        <img class="logo" src="assets/images/ariadne-spatial-logo.png" alt="ariadne_logo" />
    </div>
    <div class="password-input">
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <cds-form-group layout="vertical">
                <cds-input>
                    <label></label>
                    <input
                        [formControlName]="LOGIN_FORM_EMAIL_KEY"
                        type="text"
                        placeholder="Username"
                        autofocus
                    />
                </cds-input>
                <cds-password>
                    <label></label>
                    <input
                        [formControlName]="LOGIN_FORM_PASSWORD_KEY"
                        type="password"
                        placeholder="Password"
                    />
                </cds-password>
                <div class="button-wrapper">
                    <cds-button size="sm" action="flat" type="button" (click)="goToSignUp()">
                        Sign up
                    </cds-button>
                    <cds-button size="sm" type="submit">Login</cds-button>
                </div>
            </cds-form-group>
        </form>
    </div>
</div>
